import React, { useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import styled from 'styled-components';
import { useAlert } from "react-alert";
import { confirmAlert } from "react-confirm-alert";

export default function AddLowerBanner() {
    let alert = useAlert();

    const [files, setFiles] = useState([]);

    useEffect(() => {
        getLowerBanner()
    }, [])

    const Container = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    border-width: 2px;
    border-radius: 2px;
    border-color: red;
    border-style: dashed;
    background-color: #fafafa;
    color: #bdbdbd;
    outline: none;
    transition: border .24s ease-in-out;
    `;

    const thumbInner = {
        width: '400px',
        padding: '25px',
        border: "1px #011b6c solid",
        borderRadius: "5px"
    };

    const img = {
        width: '250px',
        height: '200px'
    };

    function StyledDropzone(props) {
        const {
            getRootProps,
            getInputProps,
            isFocused,
            isDragAccept,
            isDragReject
        } = useDropzone({
            accept: { 'image/*': [] }, onDrop: acceptedFiles => {
                setFiles(...files.push({
                    link: "", id: 0, file: acceptedFiles.map(file => Object.assign(file, {
                        preview: URL.createObjectURL(file)
                    }))
                }));
            }
        });

        const handleChange = (index, evnt) => {
            const { name, value } = evnt.target;
            const list = [...files];
            list[index][name] = value;
        };

        const deleteImage = (index, id) => {
            confirmAlert({
                customUI: ({ onClose }) => {
                    return (
                        <div className="AlertUI">
                            <h1>Aviso</h1>
                            <p>
                                ¿Deseas eliminar la imagen?
                            </p>
                            <button onClick={onClose}>No</button>
                            <button
                                onClick={() => {
                                    fetch(`${process.env.REACT_APP_URL_API}/data/deleteLowerBanner`, {
                                        method: "POST",
                                        mode: "cors",
                                        headers: {
                                            "Cache-Control": "no-cache",
                                            "Access-Control-Allow-Origin": "*",
                                        },
                                        body: JSON.stringify({ id: id }),
                                    })
                                        .then((response) => response.json())
                                        .then((datar) => {
                                            if (datar.rows > 0) {
                                                alert.show("Imagen Eliminada", {
                                                    timeout: 3000,
                                                    type: "success",
                                                    onClose: () => {
                                                        setFiles(files.filter((item, ind) => (ind !== index)));
                                                        onClose();
                                                    },
                                                });
                                            }
                                        })
                                        .catch((error) => {
                                            alert.show(
                                                "Ocurrió un error al borrar la imagen, por favor intenta de nuevo: " +
                                                error,
                                                {
                                                    timeout: 3000,
                                                    type: "error",
                                                }
                                            );
                                        });
                                }}
                            >
                                Si
                            </button>
                        </div>
                    );
                },
            });
        }

        const thumbs = files.map((file, index) => (
            <div key={index}>
                <div style={thumbInner} className="ImageBackground">
                    <div className="row text-center">
                        <div className="col-md-12">
                            <img
                                src={file.file[0].preview}
                                style={img}
                                alt='Upper File'
                                onLoad={() => { URL.revokeObjectURL(file.file[0].preview) }}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <label htmlFor="link">Link</label>
                            <input name="link" id="link" defaultValue={file.link} onBlur={(evnt) => handleChange(index, evnt)} className='form-control' />
                        </div>
                    </div>
                    {file.id != 0 ? <>
                        <div className="row">
                            <div className="col-md-12">
                                <button className='btn btn-danger mt-4 form-control' onClick={() => deleteImage(index, file.id)}>Eliminar</button>
                            </div>
                        </div>
                    </> : <></>}
                </div>
            </div>
        ));

        return (
            <div className="container">
                <Container {...getRootProps({ isFocused, isDragAccept, isDragReject })}>
                    <input {...getInputProps()} />
                    <p>Arrastra o da clic para subir las imagenes (Una por una)</p>
                </Container>
                <aside className='CalendarContainer pt-4' style={{ justifyContent: "center" }}>
                    {thumbs}
                </aside>
            </div>
        );
    }

    const saveBanner = () => {
        const formData = new FormData();

        files.map((f, i) => {
            if (typeof (f.file) != "undefined") {
                formData.append(`lowerbanner|${f.id}|${i}|${f.link.replace(/\./g,'#')}`, f.file[0]);
            }
        });

        fetch(`${process.env.REACT_APP_URL_API}/data/saveLowerBanner`, {
            method: "POST",
            mode: "cors",
            headers: {
                "Cache-Control": "no-cache",
                "Access-Control-Allow-Origin": "*",
            },
            body: formData,
        })
            .then((response) => response.json())
            .then((datar) => {
                if (datar.rows > 0) {
                    alert.show("Datos Guardados", {
                        timeout: 3000,
                        type: "success",
                        onClose: () => {
                            window.location.reload();
                        },
                    });
                }
            })
            .catch((error) => {
                alert.show(
                    "Ocurrió un error al agregar los datos del banner:" +
                    error,
                    {
                        timeout: 3000,
                        type: "error",
                    }
                );
            });
    }

    const getLowerBanner = (date) => {
        fetch(
            `${process.env.REACT_APP_URL_API}/data/getLowerBanner`,
            {
                method: "GET",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache",
                    "Access-Control-Allow-Origin": "*",
                },
            }
        )
            .then((response) => response.json())
            .then((data) => {
                var bannerpush = []
                data.map(banner => {
                    bannerpush.push({
                        id: banner.idlowerbanner,
                        link: banner.link,
                        file: [{ preview: banner.routeimage }]
                    })
                });

                setFiles(bannerpush);
            })
            .catch((error) => {
                alert.show("Ocurrió un error al obtener los datos del Banner", {
                    timeout: 3000,
                    type: "error",
                });
            });
    }

    return (
        <div className='container'>
            <div className="row">
                <p className='text-center'>Agrega o modifica las imagenes del Banner Inferior</p>
            </div>
            <button className="btn btn-success m-2" onClick={() => {
                saveBanner()
            }}>Guardar</button>
            <div className="">
                <StyledDropzone />
            </div>
        </div>
    )
}
